import PlatformActions from './PlatformActions'

export default class PPTABLEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'TABLE',
      gameCode: 'PP-TABLE-004',
      platform: 'PP',
    }

    this.gameName = 'American Blackjack'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // 68cbb6f20eb24c63fc2864cd
      roundId: `${roundId}`, // 775558764000
      betType: null,
      currency,
      betTime, // 2025-09-18T15:38:26.663+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        isBuyFreeSpin: false,
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      betInfos,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${roundId}`,
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime,
      roundId: `${roundId}`,
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betInfos,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId, // 68c3a2f6c827d548ea769f32
      roundId: `${roundId}`, // 773196504000
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
